import { API_BASE_URL } from "../config/apiBaseUrl";

const PORTAL_BASE = "/api/v1/automap/dealer-portal";

function authHeaders() {
  return { credentials: "include" };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export async function fetchDealerBuyerInterestSummary(dealerId, params = {}) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/buyer-likes/summary${qs(params)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar el resumen de interés de compradores.");
  return res.json();
}

export async function fetchDealerBuyerInterestListings(dealerId, params = {}) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/buyer-likes/listings${qs(params)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar la demanda del inventario.");
  return res.json();
}

export async function fetchDealerListingBuyerInterest(dealerId, listingId, params = {}) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/buyer-likes/listings/${encodeURIComponent(listingId)}${qs(params)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar el interés de compradores para esta publicación.");
  return res.json();
}

export async function postDealerBuyerInterestEvent(dealerId, eventType, metadata = {}) {
  return fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/buyer-likes/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ eventType, ...metadata }),
  });
}
